export enum PssrFilterDeletedStagnantOptions {
  None = 0,
  Deleted = 1,
  Stagnant = 2,
}
